import { createPortal } from 'react-dom';
import { HeadContent, Outlet, createRootRoute } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: RootComponent,
});

function Head() {
  return createPortal(<HeadContent />, document.head);
}

function RootComponent() {
  return (
    <>
      <Head />
      <Outlet />
    </>
  );
}
